import { message } from 'antd';
import { SocialType } from '../constant/social';

export const handleShareLink = (type, shareLinkData) => {
  try {
    const shareLink = generateShareLink(type, shareLinkData);

    if (shareLink) {
      window.open(shareLink, '_blank');
    } else {
      throw new Error('Unsupported social type.');
    }
  } catch (e) {
    message.error('Failed to share!');
  }
};

export const generateShareLink = (type, shareData) => {
  const templateUrl =
    process.env.REACT_APP_API_URL.replace('/api', '') + `/share/${shareData.code}`;

  const { title } = shareData;
  // Fallback title to prevent undefined in social share dialogs
  const shareTitle = title || 'Explore Treasure Locations in IGC Game: Find Your Next Adventure!';

  switch (type) {
    case SocialType.Facebook:
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        templateUrl
      )}&quote=${encodeURIComponent('IGC Gaming')}&hashtag=${encodeURIComponent(shareTitle)}`;

    case SocialType.Twitter:
      return `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        templateUrl
      )}&text=${encodeURIComponent(shareTitle)}&hashtags=${encodeURIComponent(
        'TreasureHunt,FreeIGC'
      )}&via=${encodeURIComponent('IGCApp')}&related=${encodeURIComponent('IGCCommunity')}`;

    case SocialType.Reddit:
      return `https://www.reddit.com/submit?url=${encodeURIComponent(
        templateUrl
      )}&title=${encodeURIComponent(shareTitle)}`;

    case SocialType.LinkedIn:
      return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
        templateUrl
      )}&title=${encodeURIComponent('My IGC Treasure Hunt Results')}&summary=${encodeURIComponent(
        shareTitle
      )}&source=${encodeURIComponent('IGC Official')}`;

    default:
      return null;
  }
};
